;(function () {
  angular.module('contrast.filters').filter('objectsWithLength', function () {
    return function (array, query, key, length) {
      if (!length) {
        length = 2
      }

      if (query.length >= length && angular.isDefined(key) && key.length > 0) {
        return _.filter(array, function (item) {
          return item[key].indexOf(query) > -1
        })
      }

      return array
    }
  })
})()
